// extracted by mini-css-extract-plugin
export default {"cadence":"ResultCadence_cadence__kkzCX","header":"ResultCadence_header__o7G8R","desktop":"ResultCadence_desktop__3J7Xs","smallDevice":"ResultCadence_smallDevice__fzxY5"};